export default __webpack_public_path__ + "static/media/hh-bg.290fee89.jpg";